<ng-container>
    <img [src]="'./libs/shared-ui/assets/images/' + logoName + '.svg'" alt="Foodis logo" class="logo" (click)="pressed()"/>
</ng-container>
